import React from 'react'

const MaterialSetTypeBackground = () => (
  <svg width="109" height="36" viewBox="0 0 109 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="37.4296" cy="-35.5704" r="71.4296" fill="currentColor" />
  </svg>
)

export default MaterialSetTypeBackground
